"use client"

import { ConfigSettingsPage } from "../../../modules/admin/config-settings"

interface ConfigSettingsProps {
  sidebarOpen?: boolean
}

export default function ConfigSettings({ sidebarOpen }: ConfigSettingsProps) {
  return (
    <div
      className={`w-full mb-6 p-4 lg:p-6 overflow-x-hidden ${!sidebarOpen ? "max-w-none" : "max-w-7xl mx-auto"}`}
    >
      <ConfigSettingsPage />
    </div>
  )
}

